export default __webpack_public_path__ + "static/media/TBREEL.eded717a.png";